import type { IconData } from '@stacksjs/iconify-core'

export const otherUiColorPicker: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.55 1.45L6 3H2l11 11v-4l1.55-1.55a4.95 4.95 0 0 0-7-7m1.9 12.1l.49-.49l-7-7l-.49.49a4.95 4.95 0 0 0-.855 5.855L0 14l2 2l1.595-1.595a4.95 4.95 0 0 0 5.855-.855\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiColorPicker
